export const LICENSE_KEY =
  'AppName=NotablyIncApp,Company=NotablyInc,ExpiryDate=2022-07-21,LicenseDeveloperCount=1,LicenseType=single_app,Ref=NotablyIncLicenseRef,Z=1874949607-1182481465-1589189577-2084380049232403366981763566';
